import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  extractMacroWizardTagPathArray,
  extractSelectedWizardMacro,
  extractNoMatchPageActivated,
  extractMacroWizardBreadcrumbPath,
  getSearchTypeOfSelectedAction,
  getDecisionNodeAtPath,
  isSelectedShopifyOrderRefunded,
} from '../../../../extractFromState';
import { getSelectedSubscriptionList, getShowConfirmationPage } from '../../../../selectors/tools';
import {
  setMacroWizardPath,
  clearMacroWizardPath,
  setSelectedWizardMacro,
  setNoMatchPage,
  setDecisionTreeDepth,
  setPathWasReset,
} from '../../../../actions/searchActions';
import { setSearchType } from '../../../../actions/tools/ToolActions';
import { trackMacroWizardBreadcrumbClick } from '../../../../analytics/searchEventAnalytics';
import * as util from '../../../../util';
import { DECISION_NODE_ACTIONS } from '../../../../constants/decisionTree';
import { SEARCH_SUBSCRIPTIONS } from '../../../../constants/searchTypes';
import { setAlertManagerType } from 'actions/tools/ToolActions';
import { MACRO_WIZARD } from 'constants/searchTypes';
import {
  SelectionPath,
  SelectionPathContainer,
  HouseIcon,
  SelectionPathSection,
  SelectionPathText,
} from './DTBreadcrumb.styles';

export class DTBreadcrumb extends Component {
  dropToPathIndex(i) {
    let splitPath = this.props.tagPathArray;
    // re-update tag path
    if (i <= splitPath.length) {
      splitPath = splitPath.slice(0, i);
      const newTagPath = util.joinTagArray(splitPath);
      trackMacroWizardBreadcrumbClick(newTagPath);
      this.props.setMacroWizardPath(newTagPath);
    } else {
      // updating path in decision tree
      this.props.setDecisionTreeDepth(i - splitPath.length);
    }
    if (i === 0) {
      this.props.setPathWasReset(true);
    }
  }

  generateSelectionPath() {
    const { breadcrumbPath, selectedMacro, noMatchPageActivated, clearAlertManagerType } = this.props;
    const path = this.props.breadcrumbPath.map((pathItem, i) => (
      <div key={`${pathItem}_${i}`}>
        {breadcrumbPath.length > i + 1 || selectedMacro ? (
          <SelectionPathSection link={true} onClick={() => clearAlertManagerType()} key={`${pathItem}_${i}`}>
            <SelectionPathText onClick={() => this.dropToPathIndex(i + 1)} link={true}>
              {pathItem.toUpperCase()}
            </SelectionPathText>
            <img src="/images/breadcrumb-arrow.svg" alt="arrow" />
          </SelectionPathSection>
        ) : (
          <SelectionPathSection link={false} key={`${pathItem}_${i}`}>
            <SelectionPathText link={false}>{pathItem.toUpperCase()}</SelectionPathText>
          </SelectionPathSection>
        )}
      </div>
    ));
    // All should always be the first item
    path.unshift(
      <SelectionPathSection
        key={'firstPath'}
        onClick={() => {
          clearAlertManagerType();
          this.dropToPathIndex(0);
        }}
        link={!!(breadcrumbPath.length || noMatchPageActivated)}
      >
        <SelectionPathText link={!!(breadcrumbPath.length || noMatchPageActivated)}>ALL&nbsp;</SelectionPathText>
        <img src="/images/breadcrumb-arrow.svg" alt="arrow" />
      </SelectionPathSection>
    );
    // if we have a selected macro, push that at the end
    if (selectedMacro) {
      path.push(
        <SelectionPathSection link={false} key={'selectedMacro'}>
          <SelectionPathText link={false}>
            {selectedMacro && selectedMacro.fullSubheading.toUpperCase()}&nbsp;
          </SelectionPathText>
        </SelectionPathSection>
      );
    }
    // and if we are on the no match page, use that
    if (noMatchPageActivated) {
      path.push(
        <SelectionPathSection link={false} key={'noMatch'}>
          <SelectionPathText link={false}>NO MATCH&nbsp;</SelectionPathText>
        </SelectionPathSection>
      );
    }

    return (
      <SelectionPathContainer>
        <HouseIcon
          key={'HouseIcon'}
          onClick={() => {
            clearAlertManagerType();
            this.dropToPathIndex(0);
          }}
          src="/images/breadcrumb-house.svg"
          alt="house"
        />
        <SelectionPath>{path}</SelectionPath>
      </SelectionPathContainer>
    );
  }

  // TO DO: create a selector
  showConfirmation() {
    const {
      decisionNode,
      selectedSubscriptionList,
      returnedItems,
      showConfirmationPage,
      selectedShopifyOrderRefunded,
    } = this.props;
    if (!decisionNode) {
      return false;
    }
    switch (decisionNode.action) {
      case DECISION_NODE_ACTIONS.SEND_MACRO_AND_CANCEL_SUBSCRIPTION:
      case DECISION_NODE_ACTIONS.SEND_MACRO_AND_CANCEL_SUBSCRIPTION_WITH_CURRENT_ORDER:
      case DECISION_NODE_ACTIONS.CANCEL_SUBSCRIPTION_THEN_SEND_MACRO:
        // check that there are not selected subs that are not cancelled
        return selectedSubscriptionList.filter((subscription) => subscription.status !== 'CANCELLED').length === 0;
      case DECISION_NODE_ACTIONS.SEND_MACRO_AND_REFUND_ITEMS:
        return returnedItems && this.returnedItemsAreRefunded();
      case DECISION_NODE_ACTIONS.SEND_MACRO_GIVE_STORE_CREDIT:
      case DECISION_NODE_ACTIONS.CANCEL_AMAZON_ORDER_AND_SEND_MACRO:
        return showConfirmationPage;
      case DECISION_NODE_ACTIONS.SEND_CONSTRUCTED_MACRO_AND_PARTIAL_REFUND_ITEMS:
        return selectedShopifyOrderRefunded;
      case DECISION_NODE_ACTIONS.SEND_MACRO_AND_CONFIRM_ADDRESS_CHANGE:
      case DECISION_NODE_ACTIONS.CONFIRM_LAST_MILE_REPLACEMENT_ORDER:
        return true;
      default:
        return false;
    }
  }

  showPath() {
    return !this.showConfirmation() && this.props.searchType === MACRO_WIZARD;
  }

  render() {
    return <>{this.showPath() && this.generateSelectionPath()}</>;
  }
}

const mapStateToProps = (state) => ({
  tagPathArray: extractMacroWizardTagPathArray(state),
  breadcrumbPath: extractMacroWizardBreadcrumbPath(state),
  selectedMacro: extractSelectedWizardMacro(state),
  noMatchPageActivated: extractNoMatchPageActivated(state),
  searchType: getSearchTypeOfSelectedAction(state),
  decisionNode: getDecisionNodeAtPath(state),
  selectedSubscriptionList: getSelectedSubscriptionList(state),
  showConfirmationPage: getShowConfirmationPage(state),
  selectedShopifyOrderRefunded: isSelectedShopifyOrderRefunded(state),
});

const mapStateToDispatch = (dispatch) => ({
  setMacroWizardPath: (path) => {
    dispatch(setMacroWizardPath(path));
  },
  clearAlertManagerType: () => dispatch(setAlertManagerType(null)),
  clearMacroWizardPath: () => {
    dispatch(clearMacroWizardPath());
  },
  setSelectedWizardMacro: (macro) => {
    dispatch(setSelectedWizardMacro(macro));
  },
  setNoMatchPage: (value) => {
    dispatch(setNoMatchPage(value));
  },
  setDecisionTreeDepth: (depth) => dispatch(setDecisionTreeDepth(depth)),
  goToSubscriptionSearch: () => dispatch(setSearchType(SEARCH_SUBSCRIPTIONS)),
  setPathWasReset: (value) => dispatch(setPathWasReset(value)),
});

export default connect(mapStateToProps, mapStateToDispatch)(DTBreadcrumb);
